import { Http } from "./Http";
import { getBaseEndpointUrl } from "./config";
const baseUrl = getBaseEndpointUrl();

export const tryLogin = (postData) => {
  return Http.post(baseUrl + "auth/signin", postData);
};
export const forgotPassword = (postData) => {
  return Http.post(baseUrl + "auth/forgot-password", postData);
};
export const resetPassword = (postData) => {
  return Http.post(baseUrl + "auth/create-password", postData);
};

export const dashboardData = (type, id, staff_admin) => {
  return Http.get(
    baseUrl + `dashboard/admin/${type}/${id}/${staff_admin}`,
    Http.getAuthToken()
  );
};

export const staffDashboardData = (id) => {
  return Http.get(baseUrl + `dashboard/staff/${id}`, Http.getAuthToken());
};

export const dashboardJobData = (query, page, limit, sortby, order, type) => {
  return Http.get(
    baseUrl +
    `dashboard/joblist?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}&type=${type}`,
    Http.getAuthToken()
  );
};

export const staffDashboardJobData = (
  query,
  page,
  limit,
  sortby,
  order,
  type,
  id
) => {
  return Http.get(
    baseUrl +
    `dashboard/staffjoblist?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}&type=${type}&id=${id}`,
    Http.getAuthToken()
  );
};

export const clientDashboardJobData = (id, job_id) => {
  return Http.get(
    baseUrl + `dashboard/client/${id}/${job_id}`,
    Http.getAuthToken()
  );
};

export const clientDashboardReviewData = (id, job_id) => {
  return Http.get(
    baseUrl + `dashboard/clientreview/${id}/${job_id}`,
    Http.getAuthToken()
  );
};

// <=============================== Item Categories Module =================================>

const itemCategoriesUrl = `${baseUrl}itemcategories/`;

// Get item Categories List
export const itemCategoriesList = (query, page, limit, sortby, order, id) => {
  return Http.get(
    `${itemCategoriesUrl}list?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}&id=${id}`,
    Http.getAuthToken()
  );
};

//Create item Categories
export const createItemCategories = (postData) => {
  return Http.post(`${itemCategoriesUrl}create`, postData, Http.getAuthToken());
};

//Edit item Categories
export const editItemCategories = (postData, updateID) => {
  return Http.put(
    `${itemCategoriesUrl + updateID}`,
    postData,
    Http.getAuthToken()
  );
};

// Delete item Categories
export const itemCategoriesDelete = (deleteID) => {
  return Http.delete(`${itemCategoriesUrl}${deleteID}`, Http.getAuthToken());
};

// <=============================== Item Categories Module =================================>

// <=============================== USER GROUP Module =================================>

const userGroupUrl = `${baseUrl}usergroups/`;

// Get item Categories List
export const userGroupList = (query, page, limit, sortby, order) => {
  return Http.get(
    `${userGroupUrl}list?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};

//Create item Categories
export const createUserGroup = (postData) => {
  return Http.post(`${userGroupUrl}add`, postData, Http.getAuthToken());
};

//Edit item Categories
export const editItemUserGroup = (postData, updateID) => {
  const url = `${userGroupUrl}update/${updateID}`;
  return Http.put(url, postData, Http.getAuthToken());
};

// Delete item Categories
export const userGroupDelete = (deleteID) => {
  const url = `${userGroupUrl}delete/${deleteID}`;
  return Http.delete(url);
};

// user group status update
export const userGroupStatusUpdate = (postData, updateID) => {
  return Http.put(`${userGroupUrl}updateStatus/${updateID}`, postData, Http.getAuthToken());
};

// <=============================== USER GROUP Module =================================>


// <=============================== CUSTOMER Module =================================>
const customerUrl = `${baseUrl}customer/`;
export const customerList = (query, page, limit, sortby, order) => {
  return Http.get(
    `${customerUrl}list?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};

//Create item Categories
export const createCustomer = (postData) => {
  return Http.post(`${customerUrl}add`, postData, Http.getAuthToken());
};

//Edit item Categories
export const editCustomer = (postData, updateID) => {
  const url = `${customerUrl}update/${updateID}`;
  return Http.put(url, postData, Http.getAuthToken());
};

// Delete item Categories
export const customerDelete = (deleteID) => {
  const url = `${customerUrl}delete/${deleteID}`;
  return Http.delete(`${customerUrl}delete/${deleteID}`, Http.getAuthToken());

};

// user group status update
export const customerStatusUpdate = (postData, updateID) => {
  return Http.put(`${customerUrl}updateStatus/${updateID}`, postData, Http.getAuthToken());
};


// <=============================== CUSTOMER Module =================================>


// <=============================== User Managemnt Module =================================>
const userManagementUrl = `${baseUrl}user_group/`;
export const userManagementList = (query, page, limit, sortby, order) => {
  return Http.get(
    `${userManagementUrl}list?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};

//Create item Categories
export const createUserManagement = (postData) => {
  return Http.post(`${userManagementUrl}add`, postData, Http.getAuthToken());
};

//Edit item Categories
export const editUserManagement = (postData, updateID) => {
  const url = `${userManagementUrl}update/${updateID}`;
  return Http.put(url, postData, Http.getAuthToken());
};


// Delete item Categories
export const userManagementDelete = (deleteID) => {
  return Http.delete(`${userManagementUrl}delete/${deleteID}`, Http.getAuthToken());

};

//update user status
export const updateUserStatus = (postData, updateID) => {
  return Http.put(`${userManagementUrl}updateStatus/${updateID}`, postData, Http.getAuthToken());
};

// <=============================== User Managemnt Module =================================>



// <===============================Job Module =================================>

const jobUrl = `${baseUrl}job/`;
export const jobList = (query, page, limit, sortby, order, status) => {
  return Http.get(
    `${jobUrl}list?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}&status=${status || ''}`,
    Http.getAuthToken()
  );
};

export const userJobs = ({ query, page, limit, sortby, order, type, userId }) => {
  return Http.delete(
    `${jobUrl}users?query=${query || ''}&page=${page || 1}&limit=${limit || 10}&sortby=${sortby || ''}&order=${order || ''}&type=${type || ''}&id=${userId}`,
    Http.getAuthToken()
  );
};
export const JobEventHistory = ({ query, page, limit, sortby, order, type, barcode, event_id }) => {
  return Http.get(
    `${jobUrl}jobevent-history/${barcode}?query=${query}&page=${page}&limit=${limit}&sortby=${sortby || ''}&order=${order || ''}&type=${type || ''}&event_id=${event_id || ''}`,
    Http.getAuthToken()
  );
};
export const EventStagesHistory = ({ query, page, limit, sortby, order, barcode, event_id }) => {
  return Http.get(
    `${jobUrl}event-stages-history/${barcode}?query=${query}&page=${page}&limit=${limit}&sortby=${sortby || ''}&order=${order || ''}`,
    Http.getAuthToken()
  );
};
export const AllBoxesBarocde = ({ query, page, limit, sortby, order, pickup_date, spec_id, box_status, job_spec_id, stage }) => {
  return Http.delete(
    `${jobUrl}all-boxes-list?query=${query}&page=${page}&limit=${limit}&sortby=${sortby || ''}&order=${order || ''}&pickup_date=${pickup_date || ''}&spec_id=${spec_id || ''}&box_status=${box_status || ''}&job_spec_id=${job_spec_id || ''}&stage=${stage || ''}`,
    Http.getAuthToken()
  );
};
export const EventBoxesBarocde = ({ query, page, limit, sortby, order, pickup_date, event_id, box_status }) => {
  return Http.get(
    `${dashboardUrl}box-event/${event_id}?query=${query}&page=${page}&limit=${limit}&sortby=${sortby || ''}&order=${order || ''}&pickup_date=${pickup_date || ''}&box_status=${box_status || ''}`,
    Http.getAuthToken()
  );
};
export const JobDashBoard = ({ id }) => {
  return Http.get(
    `${jobUrl}jobevent-dashboard/${id}`,
    Http.getAuthToken()
  );
};
export const JobBarcodeDashBoard = ({ id, query, page, limit, sortby, order }) => {
  return Http.get(
    `${jobUrl}jobevent-barcode-dashboard/${id}?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};

export const getuserJobsEvents = ({ jobId, userId, event_id, page, limit, query }) => {
  return Http.get(
    `${jobUrl}dataEntry/${jobId}?user_id=${userId}&event_id=${event_id || ''}&page=${page}&limit=${limit}&query=${query || ''}`, // Correct query parameters
    Http.getAuthToken()
  );
};
export const getAdminJobsEvents = ({ jobId, userId, event_id, page, limit, query }) => {
  return Http.get(
    `${jobUrl}jobevent-admin/${jobId}?user_id=${userId}&event_id=${event_id || ''}&page=${page}&limit=${limit}&query=${query || ''}`, // Correct query parameters
    Http.getAuthToken()
  );
};
export const getAdminJobsEventsDetails = ({ jobId, userId, dashboardType, workflow_id, event_id, page, limit, query }) => {
  return Http.get(
    `${jobUrl}jobevent-event-details/${jobId}?&event_id=${event_id || ''}&page=${page}&limit=${limit}&query=${query || ''}&workflow_id=${workflow_id}&dashboardType=${dashboardType || ''}`, // Correct query parameters
    Http.getAuthToken()
  );
};
export const getreWorkEventDetails = ({ role_id, jobId, user_id, event_id, page, limit, query }) => {
  return Http.get(
    `${jobUrl}get-rework-event/${jobId || ''}?page=${page}&limit=${limit}&query=${query || ''}&role_id=${role_id}&user_id=${user_id}&event_id=${event_id}`, // Correct query parameters
    Http.getAuthToken()
  );
};
export const getAllEventsAssignData = ({ jobId, role_id, user_id, workflow_id, event_id, page, limit, query, barcode }) => {
  return Http.get(
    `${jobUrl}all_event_data/${jobId}?page=${page}&limit=${limit}&query=${query || ''}&role_id=${role_id}&user_id=${user_id}&barcode=${barcode}`, // Correct query parameters
    Http.getAuthToken()
  );
};
export const getCompletedAdminJobsEventsDetails = ({ jobId, workflow_id, page, limit, query, event_id, userId }) => {
  return Http.get(
    `${jobUrl}completed-jobevent-event-details/${jobId}?user_id=${userId}&event_id=${event_id || ''}&page=${page}&limit=${limit}&query=${query || ''}&workflow_id=${workflow_id || ''}`, // Correct query parameters
    Http.getAuthToken()
  );
};
export const getuserCompletedJobsEvents = ({ jobId, workflow_id, userId, event_id, page, limit, query }) => {
  return Http.get(
    `${jobUrl}completed-job-events/${jobId}?user_id=${userId}&event_id=${event_id || ''}&page=${page}&limit=${limit}&query=${query || ''}`, // Correct query parameters
    Http.getAuthToken()
  );
};


export const jobListById = ({ editId }) => {
  return Http.get(
    `${jobUrl}/${editId}`,
    Http.getAuthToken()
  );
};

//Create item Categories
export const createJob = (postData) => {
  return Http.post(`${jobUrl}add`, postData, Http.getAuthToken());
};

//Edit item Categories
export const editJob = (postData, updateID) => {
  const url = `${jobUrl}update/${updateID}`;
  return Http.put(url, postData, Http.getAuthToken());
};

// Delete item Categories
export const jobDelete = (deleteID) => {
  return Http.delete(`${jobUrl}delete/${deleteID}`, Http.getAuthToken());

};
export const jobStatusUpdate = (postData, updateID) => {
  return Http.put(`${jobUrl}updateStatus/${updateID}`, postData, Http.getAuthToken());
};

export const addJobEvents = (updateID, postData) => {
  return Http.post(`${jobUrl}addJobEVent/${updateID}`, postData, Http.getAuthToken());
}

export const jobEventDelete = (deleteID) => {
  return Http.delete(`${jobUrl}destroyJobEvent/${deleteID}`, Http.getAuthToken());
};

export const userDataJobs = ({ payload, event_id }) => {
  return Http.get(
    `${jobUrl}userData/${payload}?event_id=${event_id}`,
    Http.getAuthToken()
  );
};

export const allocateDataToUsers = (postData) => {
  return Http.post(`${jobUrl}allocate`, postData, Http.getAuthToken());
};
export const reAllocateDataToUsers = (postData) => {
  return Http.post(`${jobUrl}reallocate`, postData, Http.getAuthToken());
};
export const allocateJobDataById = ({ editId, event_id }) => {
  return Http.get(
    `${jobUrl}allocation/${editId}?event_id=${event_id}`,
    Http.getAuthToken()
  );
};

export const eventDataInJobs = ({ jobId }) => {
  return Http.get(
    `${jobUrl}events_data/${jobId}`,
    Http.getAuthToken()
  );
};

export const uploadLogsData = ({ userId }) => {
  return Http.get(
    `${jobUrl}uploadLogs/${userId}`,
    Http.getAuthToken()
  );
};

export const uploadExcelData = ({ payload }) => {
  return Http.post(`${jobUrl}upload-excel`, payload, Http.getAuthToken())

};

export const JobEventUpdate = ({ payload }) => {
  return Http.post(`${jobUrl}update-job-event`, payload, Http.getAuthToken())
};
export const JobBarocdeStausUpdate = ({ payload }) => {
  return Http.post(`${jobUrl}udateSatusJobBarcode`, payload, Http.getAuthToken())
}
export const JobEventsReWork = ({ payload }) => {
  return Http.post(`${jobUrl}re-work-barocde`, payload, Http.getAuthToken())
}
export const JobBarcodeReassignSpec = ({ payload }) => {
  return Http.post(`${jobUrl}reassign-spec`, payload, Http.getAuthToken())
}

//get job inspection report
export const jobInspectionReport = (query, page, limit, sortby, order) => {
  return Http.get(
    `${jobUrl}jobinspection-report?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};

// <===============================Job Module =================================>


// <=============================== event validation =================================>
const eventValidationUrl = `${baseUrl}event_validation/`;
export const EventValidationByName = ({ editId }) => {
  return Http.get(
    `${eventValidationUrl}find_by_name/${editId}`,
    Http.getAuthToken()
  );
};


// <=============================== event validation =================================> 


// <=============================== event module =================================>
const eventUrl = `${baseUrl}event/`

export const createEvent = (postData) => {
  return Http.post(`${eventUrl}add`, postData, Http.getAuthToken());
};
export const createEventOrder = (postData) => {
  return Http.post(`${eventUrl}event-order`, postData, Http.getAuthToken());
};
export const eventLastStage = ({ editID }) => {
  return Http.put(
    `${eventUrl}event-last-stage/${editID}`,
    {}, // empty body
    Http.getAuthToken() // config with headers
  );
};

export const eventList = (query, page, limit, sortby, order) => {
  return Http.get(
    `${eventUrl}list?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};
export const eventListById = (id) => {
  return Http.get(
    `${eventUrl}${id}`,
    Http.getAuthToken()
  );
};
export const eventFieldStatusListById = (id, spec_id) => {
  return Http.get(
    `${eventUrl}event-filed-status/${id}?spec_id=${spec_id || ''}`,
    Http.getAuthToken()
  );
};


export const editEvent = (postData, updateID) => {
  const url = `${eventUrl}update/${updateID}`;
  return Http.put(url, postData, Http.getAuthToken());
};
export const createEventFieldStatus = (postData) => {
  return Http.post(`${jobUrl}update-job-event-field`, postData, Http.getAuthToken());
};

//update status event
export const eventStatusUpdate = (postData, updateID) => {
  return Http.put(`${eventUrl}updateStatus/${updateID}`, postData, Http.getAuthToken());
};
export const creatStationMaster = (postData) => {
  return Http.post(`${eventUrl}add-station-master`, postData, Http.getAuthToken());
};
export const stationMasterList = (query, page, limit, sortby, order) => {
  return Http.get(
    `${eventUrl}list-station-master?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};
export const editStaionMaster = (postData, updateID) => {
  const url = `${eventUrl}edit-station-master/${updateID}`;
  return Http.put(url, postData, Http.getAuthToken());
};
export const stationMasterDelete = (deleteID) => {
  return Http.delete(`${eventUrl}delete-station-master/${deleteID}`, Http.getAuthToken());

};
export const stationMasterUpdate = (postData, updateID) => {
  return Http.put(`${eventUrl}update-station-master-status/${updateID}`, postData, Http.getAuthToken());
};
// <=============================== event module =================================>

// <=============================== workflow module =================================>
const workflowUrl = `${baseUrl}workflow/`
export const createWorkflow = (postData) => {
  return Http.post(`${workflowUrl}add`, postData, Http.getAuthToken());
};

export const workflowList = (query, page, limit, sortby, order) => {
  return Http.get(
    `${workflowUrl}list?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};

export const SpecListInWorkflow = (query, page, limit, sortby, order) => {
  return Http.delete(
    `${workflowUrl}getAllSpecId?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};

export const workflowById = (id) => {
  return Http.get(
    `${workflowUrl}${id}`,
    Http.getAuthToken()
  );
};

export const editWorkFlow = (postData, updateID) => {
  const url = `${workflowUrl}update/${updateID}`;
  return Http.put(url, postData, Http.getAuthToken());
};


//update status workflow
export const workflowStatusUpdate = (postData, updateID) => {
  return Http.put(`${workflowUrl}updateStatus/${updateID}`, postData, Http.getAuthToken());
};

// <=============================== workflow module =================================>


// <=============================== Prep Team Queu module =================================>      
const prepTeamUrl = `${baseUrl}prep_queue/`
export const createPrepTeamQueue = (postData) => {
  return Http.post(`${prepTeamUrl}add`, postData, Http.getAuthToken());
};

export const PrepTeamQueueList = (query, page, limit, sortby, order) => {
  return Http.get(
    `${prepTeamUrl}list?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};


export const PrepTeamQueueById = (id) => {
  return Http.get(
    `${prepTeamUrl}${id}`,
    Http.getAuthToken()
  );
};

export const editPrepTeamQueue = (postData, updateID) => {
  const url = `${prepTeamUrl}update/${updateID}`;
  return Http.put(url, postData, Http.getAuthToken());
};

//update status workflow

export const PrepTeamUserData = ({ query = "", page = 0, limit = 0, sortby = "", order = "", userId, }) => {
  const params = new URLSearchParams({
    query,
    page,
    limit,
    sortby,
    order
  }).toString(); // Convert object to query string
  return Http.get(`${prepTeamUrl}users/${userId}?${params}`, Http.getAuthToken());
};
export const prepTeamQUeueById = ({ query, pickup_date, page, limit, editId, assign_user_id }) => {
  return Http.get(
    `${prepTeamUrl}preprocessing/${editId}?assign_user_id=${assign_user_id}&query=${query || ''}&page=${page}&limit=${limit}&pickup_date=${pickup_date || ''}`,
    Http.getAuthToken()
  );
};
export const printPrepTeamQUeueById = ({ query, pickup_date, page, limit, editId, assign_user_id }) => {
  return Http.get(
    `${prepTeamUrl}get-preprocess-by-id/${editId}?assign_user_id=${assign_user_id}&query=${query || ''}&page=${page}&limit=${limit}&pickup_date=${pickup_date || ''}`,
    Http.getAuthToken()
  );
};
export const getDeletedUniqueIDs = ({ query, pickup_date, page, limit, editId }) => {
  return Http.get(
    `${weareHouseUrl}get-delete-unique-id/${editId}?query=${query || ''}&page=${page}&limit=${limit}&pickup_date=${pickup_date || ''}`,
    Http.getAuthToken()
  );
};
export const completedprepTeamQUeueById = ({ query, page, limit, editId, pickup_date, assign_user_id }) => {
  return Http.get(
    `${prepTeamUrl}completed-preprocessing/${editId}?assign_user_id=${assign_user_id}&query=${query || ''}&page=${page || ''}&limit=${limit || ''}&pickup_date=${pickup_date || ''}`,
    Http.getAuthToken()
  );
};
export const editPreprocessing = (postData, updateID) => {
  const url = `${prepTeamUrl}preprocessing/${updateID}`;
  return Http.put(url, postData, Http.getAuthToken());
};

export const allocatePrepDataToUsers = (postData) => {
  return Http.post(`${prepTeamUrl}allocate`, postData, Http.getAuthToken());
};
export const fileTypeAdd = (postData) => {
  return Http.post(`${prepTeamUrl}add-file-type`, postData, Http.getAuthToken());
};
export const AllFileType = (query = "", page = 0, limit = 0, sortby = "", order = "") => {
  return Http.delete(`${prepTeamUrl}list-file-type?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`, Http.getAuthToken());
};

export const allocatePrepDataById = ({ editId }) => {
  return Http.get(
    `${prepTeamUrl}allocation/${editId}`,
    Http.getAuthToken()
  );
};
export const uploadExcelPrepData = (postData) => {
  return Http.post(`${prepTeamUrl}upload`, postData, Http.getAuthToken());
};
export const updatePrepData = (postData) => {
  return Http.post(`${prepTeamUrl}preprocessingData`, postData, Http.getAuthToken());
};
export const getUploadLogs = ({ userId, query,
  page,
  limit,
  sortby,
  order }) => {
  const params = new URLSearchParams({
    query,
    page,
    limit,
    sortby,
    order
  }).toString(); // Convert object to query string
  return Http.get(`${prepTeamUrl}uploadLogs/${userId}?${params}`, Http.getAuthToken());
}

// <=============================== Prep Team Queu module =================================>   


// <=============================== DashBoard =================================>  
const dashboardUrl = `${baseUrl}dashboard/`

export const dashboardList = () => {
  return Http.get(
    `${dashboardUrl}list`,
    Http.getAuthToken()
  );
};

export const dashboardBoxList = ({ id }) => {
  return Http.get(
    `${dashboardUrl}preprocess-data/${id}`,
    Http.getAuthToken()
  );
};

export const eventBoxList = () => {
  return Http.get(
    `${dashboardUrl}get-event-box`,
    Http.getAuthToken()
  );
};
export const userEventTaskList = ({ query, page, limit, sortby, order, id }) => {
  return Http.get(
    `${dashboardUrl}user-task-list/${id}?query=${query}&page=${page}&limit=${limit}&sortby=${sortby || ''}&order=${order || ''}`,
    Http.getAuthToken()
  );
};
export const userEventRecordHistoryList = ({ query, page, limit, sortby, order, id }) => {
  return Http.get(
    `${dashboardUrl}user-event-record-history/${id}?query=${query}&page=${page}&limit=${limit}&sortby=${sortby || ''}&order=${order || ''}`,
    Http.getAuthToken()
  );
};

// <=============================== DashBoard =================================>  


// <===============================  Weare House module =================================>
const weareHouseUrl = `${baseUrl}wearehouse/`
export const WeareHouseList = (query, page, limit, sortby, order) => {
  return Http.get(
    `${weareHouseUrl}list?query=${query}&page=${page}&limit=${limit}&sortby=${sortby}&order=${order}`,
    Http.getAuthToken()
  );
};

export const WeareHouseById = ({ query, page, limit, editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, }) => {
  return Http.get(
    `${weareHouseUrl}get_one_spec/${editId}?query=${query || ''}&page=${page}&limit=${limit}&uniqueIdStartValue=${uniqueIdStartValue || ''}&uniqueIdEndValue=${uniqueIdEndValue || ''}&barocdestartvalue=${barocdestartvalue || ''}&barocdeendvalue=${barocdeendvalue || ''}`,
    Http.getAuthToken()
  );
};
export const awaitingReviewBoxesApi = ({ query, page, limit, editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, pickup_date }) => {
  return Http.get(
    `${weareHouseUrl}awaiting-review-boxes/${editId}?query=${query || ''}&page=${page}&limit=${limit}&uniqueIdStartValue=${uniqueIdStartValue || ''}&uniqueIdEndValue=${uniqueIdEndValue || ''}&barocdestartvalue=${barocdestartvalue || ''}&barocdeendvalue=${barocdeendvalue || ''}&pickup_date=${pickup_date || ''}`,
    Http.getAuthToken()
  );
};
export const specAssignedBoxesApi = ({ query, page, limit, editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, pickup_date }) => {
  return Http.get(
    `${weareHouseUrl}spec-assigned-boxes/${editId}?query=${query || ''}&page=${page}&limit=${limit}&uniqueIdStartValue=${uniqueIdStartValue || ''}&uniqueIdEndValue=${uniqueIdEndValue || ''}&barocdestartvalue=${barocdestartvalue || ''}&barocdeendvalue=${barocdeendvalue || ''}&pickup_date=${pickup_date || ''}`,
    Http.getAuthToken()
  );
};
export const completedWeareHouseById = ({ query, page, limit, editId }) => {
  return Http.get(
    `${weareHouseUrl}completed-get-one-spec/${editId}?query=${query || ''}&page=${page}&limit=${limit}`,
    Http.getAuthToken()
  );
};
export const updateWeareHouse = (postData) => {
  return Http.put(`${weareHouseUrl}update`, postData, Http.getAuthToken());
};
export const deleteUniqueIDWeareHouse = (postData) => {
  return Http.put(`${weareHouseUrl}delete-box-uniue-id`, postData, Http.getAuthToken());
};
export const updateWareHouseStatus = (postData) => {
  return Http.put(`${weareHouseUrl}update-warehouse-status`, postData, Http.getAuthToken());
};
export const uploadeWeareHouse = (postData) => {
  return Http.post(`${weareHouseUrl}upload-excel-warehouse`, postData, Http.getAuthToken());
};
export const getWareHouseUploadLogs = ({ userId, query,
  page,
  limit,
  sortby,
  order }) => {
  const params = new URLSearchParams({
    query,
    page,
    limit,
    sortby,
    order
  }).toString(); // Convert object to query string
  return Http.get(`${weareHouseUrl}uploadLogs/${userId}?${params}`, Http.getAuthToken());
}

export const getHardDiskUploadLogs = ({ query,
  page,
  limit,
  sortby,
  order }) => {
  const params = new URLSearchParams({
    query,
    page,
    limit,
    sortby,
    order
  }).toString(); // Convert object to query string
  return Http.get(`${weareHouseUrl}hard-disk-logs?${params}`, Http.getAuthToken());
}
export const getDispositionUploadLogs = ({ query,
  page,
  limit,
  sortby,
  order }) => {
  const params = new URLSearchParams({
    query,
    page,
    limit,
    sortby,
    order
  }).toString(); // Convert object to query string
  return Http.get(`${weareHouseUrl}disposition-logs?${params}`, Http.getAuthToken());
}

export const hardDiskList = ({ query, page, limit, activetab }) => {
  return Http.get(
    `${weareHouseUrl}hard-disk/list?query=${query || ''}&page=${page}&limit=${limit}&activetab=${activetab}`,
    Http.getAuthToken()
  );
};
export const updateHardDisk = (postData) => {
  return Http.put(`${weareHouseUrl}update-hard-disk`, postData, Http.getAuthToken());
};
export const dispositionList = ({ query, page, limit, activetab }) => {
  return Http.get(
    `${weareHouseUrl}disposition-list?query=${query || ''}&page=${page}&limit=${limit}&activetab=${activetab}`,
    Http.getAuthToken()
  );
};
export const updateDisposition = (postData) => {
  return Http.put(`${weareHouseUrl}update-disposition`, postData, Http.getAuthToken());
};


export const viewBoxList = ({ query, page, limit, spec_id, job_spec_id, pickup_date, type }) => {
  return Http.get(
    `${weareHouseUrl}all-boxes-list?query=${query || ''}&page=${page}&limit=${limit}&spec_id=${spec_id || ''}&job_spec_id=${job_spec_id || ''}&pickup_date=${pickup_date || ''}&type=${type}`,
    Http.getAuthToken()
  );
};